import Title from '@/app/components/common/Title'
import TranslateString from '@/app/components/common/TranslateString'
import React from 'react'

interface SiteHeadingProps {
	showNewHeading: boolean
	customHeading: boolean
	selectedItem: {
		cityonly?: string
	} | null
	sanityData?: {
		headingOne?: string
	}
	isDesktop: boolean
	isMd: boolean
}

const HeadingLoader = () => <div className="min-h-[60px] w-full"></div>

const SiteHeading: React.FC<SiteHeadingProps> = ({
	showNewHeading,
	customHeading,
	selectedItem,
	sanityData,
	isDesktop,
	isMd,
}) => {
	const headingContent = () => {
		if (!showNewHeading) {
			return <HeadingLoader />
		}

		if (customHeading && !sanityData?.headingOne) {
			if (selectedItem?.cityonly) {
				return (
					<TranslateString
						context="Main"
						i18nKey="destCodePage.siteHeading"
						variables={{ location: selectedItem.cityonly }}
					/>
				)
			} else {
				return (
					<TranslateString context="Main" i18nKey="newDesign.siteHeading" />
				)
			}
		}

		return sanityData?.headingOne ? (
			<>{sanityData.headingOne}</>
		) : (
			<TranslateString context="Main" i18nKey="newDesign.siteHeading" />
		)
	}

	let textSize = isMd ? '3xl' : '2xl'
	textSize = isDesktop ? '5xl' : textSize

	return (
		<Title
			className="site-heading"
			level="1"
			size={textSize}
			testId="site-heading"
			id="site-heading"
		>
			{headingContent()}
		</Title>
	)
}

export default SiteHeading
